import type { ApiSmStateSnapshot } from "@bridge-applications/pb-types";

export function hasSpinEnergy(
    snapshot: ApiSmStateSnapshot | null | undefined,
    multiplier: number = 1,
): boolean {
    return Boolean(
        snapshot &&
        BigInt(snapshot.player.energy) >=
            BigInt(snapshot.campaign.betEnergy) * BigInt(multiplier),
    );
}
